import { useEffect } from "react";

import useUserStore from "src/store/useUserStore";

export const getUserSearchFilterDefaults = () => {
	const userInfo = useUserStore.getState().userInfo;

	return {
		compCd: userInfo?.compCd || "",
		workplaceCd: userInfo?.workplaceCd || "",
	};
};

/** 화면 최초 진입 시 로그인 사용자의 사업장/작업공정으로 검색 조건을 채운다. */
export const useInitUserSearchFilter = (
	setFilter: (filter: { compCd: string; workplaceCd: string }) => void,
	currentFilter: { compCd?: string; workplaceCd?: string },
) => {
	const userInfo = useUserStore((state) => state.userInfo);

	useEffect(() => {
		if (!userInfo) {
			return;
		}

		// Store에 이미 값이 있으면 재진입 시 덮어쓰지 않는다.
		if (currentFilter.compCd || currentFilter.workplaceCd) {
			return;
		}

		setFilter({
			compCd: userInfo.compCd || "",
			workplaceCd: userInfo.workplaceCd || "",
		});
	}, [currentFilter.compCd, currentFilter.workplaceCd, setFilter, userInfo]);
};
